import {
    ChatMessageDtoReadState,
    ChatMessageDtoSide,
    FriendDtoState,
    DefaultTimezoneScope,
    UserNotificationState,
    IsTenantAvailableOutputState,
    IncomeStatisticsDateInterval,
    RegisterTenantInputSubscriptionStartType,
    CreatePaymentDtoEditionPaymentType,
    CreatePaymentDtoPaymentPeriodType,
    CreatePaymentDtoSubscriptionPaymentGatewayType,
    SalesSummaryDatePeriod,
    Anonymous,
    OfferDtoOfferType,
    OfferDtoItemType,
    SaleTypeDTOSaleNatural,
    RawMaterialDtoItemCost,
    TransactionDtoStatus,
    PromotionDtoValueType,
    PromotionDtoPromotionType,
    PromotionFBDtoTemplateType,
} from "@shared/service-proxies/service-proxies";

export class AppChatMessageReadState {
    static Unread: number = ChatMessageDtoReadState._1;
    static Read: number = ChatMessageDtoReadState._2;
}

export class AppChatSide {
    static Sender: number = ChatMessageDtoSide._1;
    static Receiver: number = ChatMessageDtoSide._2;
}

export class AppFriendshipState {
    static Accepted: number = FriendDtoState._1;
    static Blocked: number = FriendDtoState._2;
}

export class AppTimezoneScope {
    static Application: number = DefaultTimezoneScope._1;
    static Tenant: number = DefaultTimezoneScope._2;
    static User: number = DefaultTimezoneScope._4;
}

export class AppUserNotificationState {
    static Unread: number = UserNotificationState._0;
    static Read: number = UserNotificationState._1;
}

export class AppTenantAvailabilityState {
    static Available: number = IsTenantAvailableOutputState._1;
    static InActive: number = IsTenantAvailableOutputState._2;
    static NotFound: number = IsTenantAvailableOutputState._3;
}

export class AppIncomeStatisticsDateInterval {
    static Daily: number = IncomeStatisticsDateInterval._1;
    static Weekly: number = IncomeStatisticsDateInterval._2;
    static Monthly: number = IncomeStatisticsDateInterval._3;
}

export class SubscriptionStartType {
    static Free: number = RegisterTenantInputSubscriptionStartType._1;
    static Trial: number = RegisterTenantInputSubscriptionStartType._2;
    static Paid: number = RegisterTenantInputSubscriptionStartType._3;
}

export class EditionPaymentType {
    static NewRegistration: number = CreatePaymentDtoEditionPaymentType._0;
    static BuyNow: number = CreatePaymentDtoEditionPaymentType._1;
    static Upgrade: number = CreatePaymentDtoEditionPaymentType._2;
    static Extend: number = CreatePaymentDtoEditionPaymentType._3;
}

export class AppEditionExpireAction {
    static DeactiveTenant = "DeactiveTenant";
    static AssignToAnotherEdition = "AssignToAnotherEdition";
}

export class PaymentPeriodType {
    static Monthly: number = CreatePaymentDtoPaymentPeriodType._30;
    static Annual: number = CreatePaymentDtoPaymentPeriodType._365;
}

export class SubscriptionPaymentGatewayType {
    static Paypal: number = CreatePaymentDtoSubscriptionPaymentGatewayType._1;
}

export class AppSalesSummaryDatePeriod {
    static Daily: number = SalesSummaryDatePeriod._1;
    static Weekly: number = SalesSummaryDatePeriod._2;
    static Monthly: number = SalesSummaryDatePeriod._3;
    static Yearly: number = SalesSummaryDatePeriod._4;
}
export class UserTypes {
    static Admin: number = Anonymous._1;
    static SalesMan: number = Anonymous._2;
    static Accountant: number = Anonymous._3;
    static InventoryManager: number = Anonymous._4;
}

export enum OfferTypeEnum {
    Promotion = OfferDtoOfferType._0,
    Deals = OfferDtoOfferType._1,
    DealLessPrice = OfferDtoOfferType._2,
    Package = OfferDtoOfferType._3,
}
export enum ItemTypeEnum {
    PrimaryCategory = OfferDtoItemType._0,
    Product = OfferDtoItemType._3,
    ProductCategory = OfferDtoItemType._2,
    SecondCategory = OfferDtoItemType._1,
}
export enum ItemTypeFBEnum {
    MenuItem = 0,
    ProductCategory = 1,
}
export enum StoreType {
    Store = 0,
    StoreGroup = 1,
}
export enum ValueTypeEnum {
    DiscountPercentage = PromotionDtoValueType._1,
    DiscountValue = PromotionDtoValueType._2,
    SpecificValue = PromotionDtoValueType._3,
    Points = PromotionDtoValueType._4,
    SpecificValueWithAdditionalItem = PromotionDtoValueType._5,
}
export enum PromotionTypeEnum {
    ProductsOrCategories = PromotionDtoPromotionType._1,
    InvoiceAmount = PromotionDtoPromotionType._2,
    DisCountVoucher = PromotionDtoPromotionType._3,
    GiftVoucher = PromotionDtoPromotionType._4,
    SimplePromotion = PromotionDtoPromotionType._5,
    HighestAndTheLowestPrice = PromotionDtoPromotionType._6,
}
export enum PromotionTemplateTypeEnum {
    Code = PromotionFBDtoTemplateType._1,
    Automatic = PromotionFBDtoTemplateType._2,
    Button = PromotionFBDtoTemplateType._3,
}
export enum SaleTypeEnum {
    DineIn = SaleTypeDTOSaleNatural._0,
    Pickup = SaleTypeDTOSaleNatural._1,
    Delivery = SaleTypeDTOSaleNatural._2,
}
export enum ItemCostEnum {
    AverageCost = RawMaterialDtoItemCost._0,
    FixedCost = RawMaterialDtoItemCost._1,
    LastPurchseCost = RawMaterialDtoItemCost._2,
}

export enum TransactionStatusEnum {
    Paid = TransactionDtoStatus._1,
    Suspended = TransactionDtoStatus._2,
    Void = TransactionDtoStatus._3,
    Return = TransactionDtoStatus._4,
    Ordered=TransactionDtoStatus._6
}

export enum TransactionsTemplateType {
    B2C = 1,
    B2B = 2,
}

export enum DeviceTypes {
    Mobile = 8,
    Tablet = 9,
    SecondScreen = 10,
    Kiosk=7,
    QrMena=15,
    CallCenter=13
}
export enum WorkFlowTypeEnum{
    CALLCENTER = 1,
    ORDERONLINE=2,
    KIOSIK=3
}



// WEBPACK FOOTER //
// ./src/shared/AppEnums.ts